module.exports = __webpack_public_path__ + "Gotham-Light.dd108078f3d6b0d2876c.woff";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Light.woff
// module id = ../../../../../src/assets/fonts/Gotham-Light.woff
// module chunks = 2